import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { LatitudeUITimesliderComponent } from './timeslider.component';
import { LatitudeUIDateRangeComponent } from './daterange/daterange.component';
import { LatitudeUIHistogramComponent } from './histogram/histogram.component';

import { D3Service } from 'd3-ng2-service';
import { MyDatePickerModule } from 'mydatepicker';

@NgModule({
  providers: [D3Service],
  declarations: [LatitudeUITimesliderComponent, LatitudeUIDateRangeComponent, LatitudeUIHistogramComponent],
  exports: [LatitudeUITimesliderComponent],
  imports: [CommonModule, FormsModule, MyDatePickerModule]
})
export class LatitudeUITimesliderModule { }



// WEBPACK FOOTER //
// ./src/latitude-ui/timeslider/timeslider.module.ts